import { useState, useEffect, useCallback } from "react";
import { useDispatch } from "react-redux";
import { authApi } from "../auth-api";
import { setUser, clearUser } from "../../app/stores/auth.slice";

export const useAuth = () => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const initAuth = async () => {
            try {
                const state = authApi.getAuthState();
                if (state.isAuthenticated) {
                    const user = await authApi.getCurrentUser();
                    dispatch(setUser(user));
                } else {
                    dispatch(clearUser());
                }
            } catch (err) {
                setError(err instanceof Error ? err.message : "خطا در بارگذاری اطلاعات کاربر");
                dispatch(clearUser());
            } finally {
                setIsLoading(false);
            }
        };

        initAuth();
    }, [dispatch]);

    const login = useCallback(
        async (username: string, password: string) => {
            try {
                setIsLoading(true);
                setError(null);
                const response = await authApi.login(username, password);
                localStorage.setItem("token", response.token);
                dispatch(setUser(response.user));
                return response;
            } catch (err) {
                setError(err instanceof Error ? err.message : "خطا در ورود به سیستم");
                throw err;
            } finally {
                setIsLoading(false);
            }
        },
        [dispatch]
    );

    const logout = useCallback(async () => {
        try {
            setIsLoading(true);
            setError(null);
            await authApi.logout();
            localStorage.removeItem("token");
            dispatch(clearUser());
        } catch (err) {
            setError(err instanceof Error ? err.message : "خطا در خروج از سیستم");
            throw err;
        } finally {
            setIsLoading(false);
        }
    }, [dispatch]);

    return {
        isLoading,
        error,
        login,
        logout,
    };
};
